import InformationRow from './InformationRow'

export default InformationRow
